module.exports = __webpack_public_path__ + "static/media/Phone.56b8f5f8.png";